import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";

import { environment } from "@env/environment";
import { ActionUserResolveGuide } from "@app/core/auth/identity/user.reducer";
import { FMDashboardFirstVisitComponent } from "./components/fm-dashboard-first-visit/fm-dashboard-first-visit.component";
import { CompleteNewCycleFirstVisitComponent } from "./components/complete-new-cycle-first-visit/complete-new-cycle-first-visit.component";
import { UpdateTermsFirstVisitComponent } from "./components/update-terms-first-visit/update-terms-first-visit.component";

@Injectable()
export class FirstVisitService {
  private dialog = inject(MatDialog);
  private readonly store = inject<Store<any>>(Store);

  public FMDashboardPageFirstVisit(userRoles): Observable<string> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.data = { userRoles: userRoles };

    const dialogRef = this.dialog.open(FMDashboardFirstVisitComponent, config);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.store.dispatch(
          new ActionUserResolveGuide({
            guidename: res,
            userGuidename: "fmKeyContactBridgingScreen",
            base_url: environment.client.base_url,
            dialog: true
          })
        );
      }
    });
    return dialogRef.afterClosed();
  }

  public completePageNewCycleFirstVisit(): Observable<string> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;

    const dialogRef = this.dialog.open(CompleteNewCycleFirstVisitComponent, config);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.store.dispatch(
          new ActionUserResolveGuide({
            guidename: res,
            userGuidename: "newCycleCompleterInformation",
            base_url: environment.client.base_url,
            dialog: true
          })
        );
      }
    });
    return dialogRef.afterClosed();
  }

  public updatedTermsFirstVisit(isKeycloakProvider: boolean): Observable<string> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.data = { isKeycloakProvider };

    const dialogRef = this.dialog.open(UpdateTermsFirstVisitComponent, config);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.store.dispatch(
          new ActionUserResolveGuide({
            guidename: res,
            userGuidename: "processedUpdatedTerms",
            base_url: environment.client.base_url,
            dialog: true
          })
        );
      }
    });
    return dialogRef.afterClosed();
  }
}
